import {
  GenerativeCardActions,
  GenerativeCardBody,
  GenerativeCardFooter,
  GenerativeCardHeader,
  GenerativeCardRoot,
} from "./generative-card-components";

export const GenerativeCard = {
  Root: GenerativeCardRoot,
  Header: GenerativeCardHeader,
  Body: GenerativeCardBody,
  Actions: GenerativeCardActions,
  Footer: GenerativeCardFooter,
};
